<script setup lang="ts">
import { defaultIconType, type IconType } from '@/types/components/IconType'
import { type Colors } from '@/types/constants/ColorValues'

type IconProps = {
    icon?: IconType | string
    type?: Colors
}

withDefaults(defineProps<IconProps>(), {
    icon: () => defaultIconType
})
</script>

<template>
    <b-icon
        v-if="typeof icon === 'string'"
        size="medium"
        :type="type ? `is-${type}` : ''"
        :icon="icon"
        v-bind="$attrs" />
    <span
        v-else-if="!!icon.path"
        :class="`icon svg-icon ${icon.type || type ? `has-text-${icon.type ?? type}` : ''} medium`"
        v-bind="$attrs">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" v-bind="$attrs">
            <path fill="currentColor" :d="icon.path" />
        </svg>
    </span>
    <b-icon
        v-else
        size="medium"
        :icon="icon.label"
        :type="icon.type || type ? `is-${icon.type ?? type}` : ''"
        v-bind="$attrs" />
</template>

<style scoped lang="scss">
.icon {
    color: var(--color-text);
}
.svg-icon {
    &.icon svg {
        height: 100%;
        width: 100%;
    }
}
</style>
